import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';
import AesUtil from './scripts/cryptoutils';

interface EncryptObject {
  encryptionData: string;
  keySize: number;
  iteration: number;
  rsaKeySize: number;
  config: {
    data: string;
    headers: object;
    method: string;
    url: string;
    encryptedUrl: string;
  };
  challenge: string;
  rsaPublickKey: string;
  challengePayload: string;
}

export const encryption = (param: EncryptObject) => {
  const aes = new AesUtil(param.keySize, param.iteration);

  // getPLChallenge
  const plainText = JSON.stringify({
    payload: param.config.data,
    challenge: param.challenge
  })

  // genPlHash
  const hash = CryptoJS.SHA256(plainText).toString();

  // genPlKeys
  const iv = aes.generateIV();
  const salt = aes.generateSalt();

  // genPlSignature
  const sm = JSON.stringify({ salt, iv, hash });

  const rsa = new JSEncrypt({ default_key_size: param.rsaKeySize.toString() });
  rsa.setPublicKey(param.rsaPublickKey);
  const encryptedText = rsa.encrypt(sm);

  // genPLEncrypt
  const cipherText = aes.encrypt(salt, iv, hash, plainText);

  param.config.data = param.config.encryptedUrl ? `?e=${encryptedText}` : `${encryptedText}.${cipherText}`;
  param.config.headers = {
    ...param.config.headers,
    // 'Content-Type': 'application/json',
    'X-Challenge-Payload': param.challengePayload
  };

  if (param.config.method === 'GET') {
    param.config.headers['X-Mbtc-Hfab'] = param.config.encryptedUrl ? cipherText : `${encryptedText}.${cipherText}`;
    param.config.url = param.config.encryptedUrl ? `${param.config.encryptedUrl}${param.config.data}` : param.config.url;
  }

  param.encryptionData = `${salt}${iv}${hash}`;

  return param;
};


export const decryption = (config: {
  salt: string
  iv: string
  hash: string
  cipherText: string
}) => {
  const param = {
    keySize: 256,
    iteration: 1000,
    salt: config.salt,
    iv: config.iv,
    hash: config.hash,
    cipherText: config.cipherText
  };

  const aes = new AesUtil(param.keySize, param.iteration);

  let decryptRes = null;
  try {
    decryptRes = aes.decrypt(param.salt, param.iv, param.hash, param.cipherText);
  } catch (err) {
    decryptRes = `${err.message}`
  }

  return decryptRes;
};
